module.exports = __webpack_public_path__ + "static/media/img21.3ae3751d.png";